import React from 'react';

/**
 * The stroke glyphs drawn on more than one scheduling surface.
 *
 * The recruiter's settings screen and the applicant's booking page each keep their own icon component
 * -- the booking page loads no ATS stylesheet, so it genuinely cannot use the shared sprite -- but they
 * were also each drawing `chevronLeft`, `chevronRight`, `check`, `calendar` and `clock` from different
 * path data. Same concepts, visibly different shapes: the ticks had different proportions and the
 * chevrons were written from opposite ends. Nothing was broken; the product simply looked like two
 * products.
 *
 * Both wrappers use the same 24x24 viewBox, `fill="none"`, `stroke="currentColor"` and a 1.7 stroke
 * width, so one definition renders identically in both. Surface-specific glyphs stay in their own file;
 * only the overlap lives here.
 */
export const SHARED_GLYPHS = {
    chevronLeft: <path d="m15 18-6-6 6-6" />,
    chevronRight: <path d="m9 18 6-6-6-6" />,
    check: <path d="M20 6 9 17l-5-5" />,
    calendar: <><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" /></>,
    clock: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>,
};
